var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_core.js
// module id = 43
// module chunks = 1